module.exports = __webpack_public_path__ + "static/images/rule_btn.f7e5b36.png";